import { API } from "../redux/auth/authApi";
import { showLoader, hideLoader } from "../redux/loader/loaderSlice";
import { toast } from "react-toastify";

const activeToasts = new Set();

const showToastOnce = (message, options = {}) => {
  if (!message) return;

  if (!activeToasts.has(message)) {
    activeToasts.add(message);

    toast.error(message, {
      ...options,
      onClose: () => activeToasts.delete(message),
    });
  }
};

export const setupAxiosInterceptors = (store) => {

  API.interceptors.request.use((config) => {
    store.dispatch(showLoader());

    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  API.interceptors.response.use(
    (response) => {
      store.dispatch(hideLoader());
      return response;
    },

    (error) => {
      store.dispatch(hideLoader());

      if (!error.response) {
        if (!error.config?.skipGlobalErrorHandler) {
          showToastOnce(
            "Unable to connect. Please check your internet connection or try again.",
            { autoClose: 5000 }
          );
        }
        return Promise.reject(error);
      }

      const status = error.response.status;

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Something went wrong";

      if (error.config?.skipGlobalErrorHandler) {
        return Promise.reject(error);
      }

      if (status === 401) {
        localStorage.removeItem("user");
        localStorage.removeItem("token");

        showToastOnce("Session expired. Please login again.");

        setTimeout(() => {
          window.location.href = "/sign-in";
        }, 1500);
      } 
      
      else if (status === 429) {
        showToastOnce(
          message ||
            "You’re making requests too quickly. Please wait a few minutes and try again.",
          { autoClose: 6000 }
        );
      } 
      
      else {
        showToastOnce(message);
      }

      return Promise.reject(error);
    }
  );
};